import CometMarquee from 'comet-marquee';
import 'comet-marquee/dist/comet-marquee.css';

window.initClientsMarquee = function initClientsMarquee() {
  const clientsMarqueeElsArr = document.querySelectorAll(
    '.text-sec__tech-marquee'
  );

  if (clientsMarqueeElsArr.length) {
    clientsMarqueeElsArr.forEach((marqueeEl, idx) => {
      const marquee = new CometMarquee(marqueeEl, {
        speed: 60,
        adaptivePause: true,
        reverse: idx % 2 === 1,
        pauseOnInvisible: true,
        initialShift: true,
      });
    });
  }
};

if (!document.querySelector('.bold-loader-new')) {
  initClientsMarquee();
}
